// 管理员相关的api
import request from '@/utils/request'
// 获取管理员列表
export function getAdministratorList(data) {
  return request({
    url: '/admin/setting/webUser/list',
    method: 'post',
    data: data
  })
}
// 获取全部角色列表
export function getAllRoles(data) {
  return request({
    url: '/admin/setting/webRole/list',
    method: 'post',
    data
  })
}
// 添加管理员
export function addAdministrator(data) {
  return request({
    url: '/admin/setting/webUser/register',
    method: 'post',
    data: data
  })
}

// 更新管理员信息
export function updateAdministrator(data) {
  return request({
    url: '/admin/setting/webUser/edit',
    method: 'post',
    data: data
  })
}
// 重置密码
export function resetPas(data) {
  return request({
    url: '/admin/setting/webUser/resetPas',
    method: 'post',
    data
  })
}
